import React from "react"

export default function InputField({ label, required = false, error, labelExtra = null, ...props }) {
    return (
        <div className="mb-3">
            <label className="form-label fw-semibold" style={{ fontSize: "0.875rem" }}>
                {label}
                {required && <span className="text-danger ms-1">*</span>}
                {labelExtra}
            </label>
            <input
                {...props}
                className={`form-control${error ? " is-invalid" : ""}`}
            />
            {error ? (
                <div className="text-danger small mt-1">{error}</div>
            ) : null}
        </div>
    )
}
